export default {
  // Page metadata
  'meta.title': 'Términos de Servicio - timer.today',
  'meta.description': 'Términos de servicio y acuerdo de uso para la plataforma de herramientas de cronometraje en línea timer.today. Conozca nuestras reglas de servicio, derechos y responsabilidades de los usuarios.',

  // Page header
  'page.title': 'Términos de Servicio',
  'page.lastUpdated': 'Última actualización: {{date}}',
  'page.intro': 'Bienvenido a timer.today. Estos términos y condiciones describen las reglas y regulaciones para el uso del sitio web de timer.today, ubicado en timer.today.',

  // Section 1
  'section1.title': '1. Aceptación de los Términos',
  'section1.content': 'Al acceder y utilizar este sitio web, usted acepta y acuerda estar sujeto a los términos y disposiciones de este acuerdo. Si no está de acuerdo en cumplir con lo anterior, por favor no utilice este servicio.',

  // Section 2
  'section2.title': '2. Descripción del Servicio',
  'section2.intro': 'timer.today proporciona herramientas de cronometraje en línea gratuitas que incluyen:',
  'section2.timer': 'Temporizador de Cuenta Regresiva - Temporizador personalizable para productividad, cocina y gestión del tiempo',
  'section2.stopwatch': 'Cronómetro - Herramienta de cronometraje de alta precisión para deportes, entrenamiento y cronometraje preciso',
  'section2.worldclock': 'Reloj Mundial - Visualización en tiempo real de zonas horarias globales',

  // Section 3
  'section3.title': '3. Licencia de Uso',
  'section3.intro': 'Se otorga permiso para usar temporalmente timer.today solo para visualización transitoria personal y no comercial. Esta es la concesión de una licencia, no una transferencia de título, y bajo esta licencia usted no puede:',
  'section3.item1': 'modificar o copiar los materiales',
  'section3.item2': 'usar los materiales con fines comerciales o para cualquier exhibición pública',
  'section3.item3': 'intentar aplicar ingeniería inversa a cualquier software contenido en el sitio web',
  'section3.item4': 'eliminar cualquier derecho de autor u otras notaciones de propiedad de los materiales',

  // Section 4
  'section4.title': '4. Privacidad y Datos',
  'section4.intro': 'timer.today se compromete a proteger su privacidad:',
  'section4.item1': 'No recopilamos ni almacenamos información personal',
  'section4.item2': 'La configuración del temporizador se almacena localmente en su navegador',
  'section4.item3': 'No rastreamos el comportamiento del usuario ni los patrones de uso',
  'section4.item4': 'No se utilizan cookies con fines de seguimiento',

  // Section 5
  'section5.title': '5. Descargo de Responsabilidad',
  'section5.content': 'Los materiales en timer.today se proporcionan "tal cual". timer.today no ofrece garantías, expresas o implícitas, y por la presente renuncia y niega todas las demás garantías, incluidas, sin limitación, garantías o condiciones implícitas de comerciabilidad, idoneidad para un propósito particular o no infracción de propiedad intelectual u otra violación de derechos.',

  // Section 6
  'section6.title': '6. Limitaciones',
  'section6.content': 'En ningún caso timer.today o sus proveedores serán responsables de cualquier daño (incluyendo, sin limitación, daños por pérdida de datos o beneficios, o debido a interrupción del negocio) que surja del uso o la imposibilidad de usar los materiales en timer.today, incluso si timer.today o su representante autorizado ha sido notificado oralmente o por escrito de la posibilidad de tal daño.',

  // Section 7
  'section7.title': '7. Precisión de los Materiales',
  'section7.content': 'Los materiales que aparecen en timer.today podrían incluir errores técnicos, tipográficos o fotográficos. timer.today no garantiza que ninguno de los materiales en su sitio web sea preciso, completo o actual. timer.today puede realizar cambios en los materiales contenidos en su sitio web en cualquier momento sin previo aviso.',

  // Section 8
  'section8.title': '8. Modificaciones',
  'section8.content': 'timer.today puede revisar estos términos de servicio para su sitio web en cualquier momento sin previo aviso. Al usar este sitio web, usted acepta estar sujeto a la versión actual de estos términos de servicio.',

  // Section 9
  'section9.title': '9. Información de Contacto',
  'section9.intro': 'Si tiene alguna pregunta sobre estos Términos de Servicio, contáctenos en:',
  'section9.email': 'Correo electrónico:',
  'section9.emailSubject': 'Consulta sobre Términos de Servicio - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Todos los derechos reservados.'
};
